import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SuppliersService } from '../suppliers.service';
import { Supplier } from '../suppliers.model';
import { Page } from '../../../models/page-wrapper.model';

@Component({
  selector: 'app-suppliers-list',
  templateUrl: './list-suppliers.component.html',
  styleUrl: './list-suppliers.component.css',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
    RouterModule,
  ],
  providers: [ConfirmationService, MessageService],
})
export class ListSuppliersComponent implements OnInit {
  suppliers: Supplier[] = [];
  totalRecords = 0;
  isLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private SuppliersService: SuppliersService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {  
    this.loadSuppliers();
  }

  loadSuppliers(): void {
    this.isLoading = true;
    this.SuppliersService.getAllSuppliers({
        page: 0,
        size: 10,
      }).subscribe({
        next: (page: Page<Supplier>) => {
        console.log(page.content);
        stop();
        this.suppliers = page.content;
        this.totalRecords = page.totalElements;
        this.isLoading = false;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load Suppliers units.',
        });
      },
    });
  }

  deleteSupplier(supplier: Supplier): void {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${supplier.supplierName}?`,
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.SuppliersService
          .deleteSupplier(supplier.id)
          .subscribe({
            next: () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Supplier deleted successfully',
              });
              this.loadSuppliers();
            },
            error: () => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to delete Supplier.',
              });
            },
          });
      },
    });
  }

  createSupplier() {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['supplier', 'create'] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }

  editSupplier(id: number): void {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['supplier', 'edit', id] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }
}
